import styled from 'styled-components';

export const QuerySelectFiltersContainer = styled.div`
  .query-select-filters-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;

    > span {
      color: ${({ theme }) => theme.colors.text};
      font-size: ${({ theme }) => theme.fontSizes.default};
      font-weight: bold;
    }

    .ant-btn {
      margin-left: 8px;
      display: flex;
      align-items: center;

      svg {
        margin-right: 8px;
      }
    }
  }

  .query-select-filters-options-container {
    padding: 0 16px;

    .ant-divider-inner-text {
      color: ${({ theme }) => theme.colors.text2};
      font-size: ${({ theme }) => theme.fontSizes.small};
    }
  }

  .query-select-filters-options-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 8px;
    max-width: 470px;
    justify-items: start;
    padding: 10px;
  }
`;
